import { useNavigate } from "react-router-dom";
import Header from "../../../components/marketplace/Header";
const IndustryStatusMessage = () => {
  const navigate = useNavigate();

  return (
       <>
       <Header/>
    <div className="flex items-center justify-center mt-20 px-4">
      <div className="bg-white p-8 rounded-2xl s max-w-2xl text-center">
        <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <div className="flex items-center gap-2 justify-center mb-4">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <h2 className="text-xl font-semibold text-gray-900">
            Document Status Update
          </h2>
        </div>
        
        <div className="space-y-4 text-left">
          <p className="text-gray-600 leading-relaxed">
            Your document is currently under review. This process may take <span className="font-semibold text-gray-900">1 to 3 days</span>.
          </p>
          
          <p className="text-gray-600 leading-relaxed">
            Once your document is approved, you will receive an email. After that, you can log in to view your dashboard and access all features.
          </p>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-100">
          <span
            onClick={() => navigate("/home")}
            className="text-[#0f6abf] font-semibold cursor-pointer hover:underline inline-flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Return to Home
          </span>
        </div>
      </div>
    </div>
     </>
  );
};

export default IndustryStatusMessage;